import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { string, func } from 'prop-types'
import { parkingIcons } from '../../../../utils/ParkingIcons'
import { filterSignsBySub } from '../../../../store/Actions'
import { toggleSubTypeMenu } from '../../../../store/Actions/UiActions'
import { updateClusterColor } from '../../../../store/Actions/MapActions'
import { List, Image } from 'semantic-ui-react'

class SubTypeItem extends PureComponent {
  handleFilter = (subtype, color) => {
    this.props.filterSignsBySub(subtype)
    this.props.updateClusterColor(color)
    this.props.toggleSubTypeMenu(false)
  }

  render() {
    const { subtype, color } = this.props
    return (
      <List.Item onClick={() => this.handleFilter(subtype, color)}>
        <Image avatar src={parkingIcons(subtype)} />
        <List.Content>
          <List.Header>{subtype}</List.Header>
        </List.Content>
      </List.Item>
    )
  }
}

SubTypeItem.propTypes = {
  subtype: string.isRequired,
  color: string.isRequired,
  filterSignsBySub: func.isRequired,
  updateClusterColor: func.isRequired,
  toggleSubTypeMenu: func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  filterSignsBySub: value => dispatch(filterSignsBySub(value)),
  updateClusterColor: value => dispatch(updateClusterColor(value)),
  toggleSubTypeMenu: value => dispatch(toggleSubTypeMenu(value)),
})

export default connect(
  null,
  mapDispatchToProps
)(SubTypeItem)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SubTypeMenu/SubTypeItem.jsx